import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

// async function create(data) {
//   const response = await http
//     .postData("/asesmen-awal-gadar-keperawatan2", data)
//     .catch(err => {
//       ErrorAlert.showErrorAlert(err);

//       return Promise.reject(err);
//     });

//   return response;
// }

// async function update(id, data) {
//   const response = await http
//     .putData(`/asesmen-awal-gadar-keperawatan2/${id}`, data)
//     .catch(err => {
//       ErrorAlert.showErrorAlert(err);

//       return Promise.reject(err);
//     });

//   return response;
// }

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/asesmen-awal-gadar-keperawatan2`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  const data = isEmpty(response?.data) ? null : response.data;

  return data;
}

async function find(id: number) {
  const response = await http
    .getData(`/asesmen-awal-gadar-keperawatan2/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  const data = isEmpty(response?.data) ? null : response.data;

  return data;
}

// async function destroy(id: number) {
//   const response = await http
//     .deleteData(`/asesmen-awal-gadar-keperawatan2/${id}`)
//     .catch(err => {
//       ErrorAlert.showErrorAlert(err);

//       return Promise.reject(err);
//     });

//   return response;
// }

export default {
  // create,
  // update,
  getByRegister,
  find,
  // destroy
};
